import { graphql, useStaticQuery } from 'gatsby';

export const useDolInfo = () => {
  const data = useStaticQuery(graphql`
    {
      gcms {
        jsonContanier(where: { name: "dol-info-v2" }) {
          content
        }
      }
    }
  `);

  return data.gcms.jsonContanier.content;
};
